import {} from 'interfaces/manualApprover';
export const APPROVAL_LEVEL_ERROR_TITLE = 'Please review your approval selection';
export const APPROVER_FIELD_PREFIX = 'approvers-';
export const ManualApproverPlacementMap = {
    FIRST: 'first',
    LAST: 'last',
};
